import React, { useEffect, useState, useMemo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { selectUserData } from '../features/userSlice';
import GuideModal from '../components/GuideModal';
import illu1 from '../assets/illustrations/illu1.jpg';
import illu2 from '../assets/illustrations/illu2.jpg';
import illu3 from '../assets/illustrations/illu3.jpg';
import './Home.css';

const Home = () => {
  const [showGuide, setShowGuide] = useState(false);
  const userData = useSelector(selectUserData);
  const userHierarchyLevel = userData?.role?.hierarchy_level;

  const userName = useMemo(() => {
    if (!userData) return '';
    return userData.first_name || userData.username || '';
  }, [userData]);

  useEffect(() => {
    document.title = 'TRAC - Home';
  }, []);

  return (
    <div className="home-page">
      <Container fluid className="home-container">
        <Row className="home-row">
          {/* Left Content Column */}
          <Col lg={6} className="home-content-col">
            <div className="home-content">
              <h1 className="home-hero-title" style={{ marginBottom: '20px' }}>
                Willkommen {userName} im TRAC-Tool von Great{'\u00A0'}Place{'\u00A0'}To{'\u00A0'}Work<sup>®</sup>
              </h1>

              <p className="home-description">
                TRAC* ist unser zentrales Steuerungstool für die Umsetzung und Dokumentation von Entwicklungsmaßnahmen nach Mitarbeitendenbefragungen.
              </p>
              <p className="home-description">
                Erfasse Handlungsfelder, Ziele und Maßnahmen aus der Befragung, gib Rückmeldung zum Umsetzungsstand und behalte die Entwicklung in Deinem Verantwortungsbereich im Blick.
              </p>

              <h3 className="home-start-title">So startest Du</h3>

              <button 
                type="button" 
                className="home-guide-button" 
                onClick={() => setShowGuide(true)}
              >
                Guide starten
              </button>

              <p className="home-trac-subtitle pt-5">
                *TRAC: Tracking Results and Actions for Culture
              </p>
            </div>
          </Col>

          {/* Right Image Grid Column */}
          <Col lg={6} className="home-image-col">
            <div className="home-image-grid">
              {/* Top Left Image */}
              <div className="grid-image grid-image-top-left">
                <img src={illu3} alt="Team member 1" />
              </div>
              
              {/* Right Image (full height) */}
              <div className="grid-image grid-image-right">
                <img src={illu2} alt="Team member 2" />
              </div>
              
              {/* Bottom Left Image */}
              <div className="grid-image grid-image-bottom-left">
                <img src={illu1} alt="Team member 3" />
              </div>
              
              {/* Red Accent Rectangles */}
              <div className="red-accent red-accent-right"></div>
              <div className="red-accent red-accent-bottom"></div>
            </div>
          </Col>
        </Row>
      </Container>

      <GuideModal 
        show={showGuide} 
        onHide={() => setShowGuide(false)} 
        userHierarchyLevel={userHierarchyLevel}
      />
    </div>
  );
};

export default Home;